// extracted by mini-css-extract-plugin
export default {"body3":"body-03_body3__0t0gC","semibold":"body-03_semibold__Go+-c","bold":"body-03_bold__vgFr4","error":"body-03_error__RHP0v","link":"body-03_link__z6KNZ"};